import Icon from "../../../../components/Icon/Icon";
import Categories from "../variables/Categories";
import MenuDropdown from "../../../../components/dropdown/MenuDropdown/MenuDropdown";
import {Link} from "react-router-dom";
import {useState} from "react";

import React from "react";




export function CategoryBox({className, icon, name, options, ...props}) {
    return (
        <MenuDropdown
            button={
                <div
                    className={`flex flex-row min-w-max  gap-2 lg:gap-4  justify-center items-center cursor-pointer  ${className}`}>
                    <Icon name={icon} className={" w-8 lg:w-10"}/>
                    <p>
                        {name}
                    </p>
                    <Icon name={"arrowDown"} className={"text-tertiary-900"}/>


                </div>
            }

            classNames={" py-2 top-12 right-[10px]  w-max"}
        >
            <div
                className=" w-56 flex-col  justify-start rounded-lg bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-darkTheme-700 dark:text-white dark:shadow-none">

                {options?.map((option, index) => {
                    return (
                        <Link
                            key={index}
                            to={`/practice/${option.value}`}
                            className={" justify-center border-b-[1px] py-1 hover:bg-gray-100 cursor-pointer items-center flex"}>
                            <p  className={"font-semibold "}>
                                {option.name}
                            </p>

                        </Link>

                    )
                })}
            </div>
        </MenuDropdown>


    )
}


export default function CategorySelection({className, ...props}) {
    const [selectedCat,selectCat] = useState("Wap")

    return (
        <div
            className={`flex w-full  mt-8 lg:mt-0 flex-wrap   max-w-full justify-center items-center flex-row gap-10 ${className}`}>
            {
                Categories.map((category, i) => (
                    <React.Fragment key={i}>
                    <CategoryBox
                                 selectedCat={selectedCat}
                                    selectCat={selectCat}
                                 {...category}/>
                        {i + 1 < category?.options?.length &&
                            <div className={"w-[1px] hidden lg:flex bg-gray-200 h-14"}/>}
                    </React.Fragment>

                ))
            }

        </div>

    )
}
